import { Box, FormField } from '@wix/design-system';
import { ChevronRight } from '@wix/wix-ui-icons-common/lazy';
import { EditorSubType } from '@wix/editor-platform-sdk-types';
import classNames from 'classnames';
import React from 'react';

import { DATA_HOOKS } from './constants';
import { getEditorSubType } from '../../../../utils';

import styles from './GroupPreview.module.scss';

export type GroupPreviewProps = {
  disabled?: boolean;
  onClick: () => void;
  children: React.ReactNode;
  dataHook?: string;
  variant?: EditorSubType;
};

export const GroupPreview: React.FC<GroupPreviewProps> = ({
  disabled,
  onClick,
  children,
  dataHook,
  variant = getEditorSubType(),
}) => {
  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (disabled) {
      return;
    }
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onClick();
    }
  };

  return (
    <FormField dataHook={dataHook}>
      <div
        onClick={disabled ? undefined : onClick}
        role="button"
        tabIndex={disabled ? -1 : 0}
        onKeyDown={handleKeyDown}
        className={classNames(styles.container, {
          [styles.studio2]: variant === EditorSubType.Studio2,
        })}
        data-hook={DATA_HOOKS.GROUP_PREVIEW}
      >
        <Box
          className={classNames({
            [styles.disabled]: disabled,
            [styles.content]: !disabled,
          })}
          border="solid 1px"
          borderRadius="6px"
          padding="SP1 SP2 SP1 SP1"
          width="100%"
          dataHook={disabled ? DATA_HOOKS.DISABLED_GROUP_PREVIEW : ''}
        >
          {children}
          <Box className={styles.chevron} alignSelf="center">
            <ChevronRight />
          </Box>
        </Box>
      </div>
    </FormField>
  );
};
